import React, { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell } from "@/components/ui/table";
import { DataToolbar, StatusBadge } from "@/components/data/Common";
import { api } from "@/lib/api";

export default function Lubrication() {
  const [list, setList] = useState([]);
  const [eqs, setEqs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/lubrication").then((r) => setList(r.data));
    api.get("/equipment").then((r) => setEqs(r.data));
  }, []);
  const eqMap = Object.fromEntries(eqs.map((e) => [e.id, e]));
  const today = new Date().toISOString().slice(0, 10);
  const filt = list.filter((l) => !q || (l.lubricant || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <AppLayout title="Lubrication Schedule" subtitle="Grease & oil schedules with due-date alerts">
      <DataToolbar search={q} setSearch={setQ} searchTestId="lub-search-input" />
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Equipment</TableHead><TableHead>Lubricant</TableHead><TableHead>Type</TableHead>
              <TableHead className="text-right">Qty</TableHead><TableHead>Last Done</TableHead>
              <TableHead>Next Due</TableHead><TableHead>Responsible</TableHead><TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filt.map((l) => {
              const overdue = l.next_due < today;
              return (
                <TableRow key={l.id} data-testid={`lub-row-${l.id}`}>
                  <TableCell className="font-mono text-xs">{eqMap[l.equipment_id]?.code || "—"}</TableCell>
                  <TableCell>{l.lubricant}</TableCell>
                  <TableCell className="text-slate-500">{l.type}</TableCell>
                  <TableCell className="text-right font-mono">{l.quantity}</TableCell>
                  <TableCell className="font-mono text-xs">{l.last_done}</TableCell>
                  <TableCell className="font-mono text-xs">{l.next_due}</TableCell>
                  <TableCell className="text-xs text-slate-500">{l.responsible}</TableCell>
                  <TableCell><StatusBadge status={overdue ? "critical" : "active"} /></TableCell>
                </TableRow>
              );
            })}
            {!filt.length && <TableRow><TableCell colSpan={8} className="text-center py-12 text-slate-400">No lubrication records</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </AppLayout>
  );
}
